import { Route, Routes } from "react-router";
import Products from "./products/products";
import CreateProduct from "./products/createproduct";
import Dashboard from "./dashboard/dashboard";
import Customers from "./customers/customers";
import CustomerDetails from "./customers/customer_details";
import { CustomersHandler } from "./customers/handler";
import { OrdersHandler } from "./orders/handler";
import Orders from "./orders/orders";
import Settings, {
  Account,
  Notifications,
  Security,
} from "./settings/settings";
import { TradesHandler } from "./trades/handler";
import Trades from "./trades/trades";
import OrderDetails from "./orders/order_details";
import { ProductsHandler } from "./products/handler";
import CategoryProducts from "./products/category_products";
import ViewProduct from "./products/view_product";
import { ShippingHandler } from "./shipping/handler";
import Shipping from "./shipping/shipping";
import ShippingAddress from "./shipping/shippingaddresses";
import ShippingDetails from "./shipping/shopping_details";
import Banners from "./settings/banners/banners";
import Roles from "./settings/roles_permission/roles";
import Rates from "./rates/rates";
import Giftcards from "./rates/giftcards/giftcards";
import CryptoRate from "./rates/giftcards/crypto_rate";
import ShippingRate from "./rates/giftcards/shipping_rate";
import DropoffDetails from "./shipping/DropoffDetails";
import SellGiftcards from "./rates/giftcards/SellGiftCardRate";
import PlatformRate from "./rates/giftcards/PlatformRate";
import CryptoSellRate from "./rates/giftcards/sell_crypto_rate";
import Withdrawals from "./withdrawals/withdrawals";
import Campaigns from "./campaigns/campaigns";
import CampaignEditor from "./campaigns/campaign_editor";
import BvnWatchlist from "./bvnWatchlist/bvnWatchlist";
import { MonitoringLayout } from "./monitoring/shared";
import MonitoringOverview from "./monitoring/overview";
import MonitoringAlerts from "./monitoring/alerts";
import AlertDetail from "./monitoring/alert_detail";
import MonitoringCases from "./monitoring/cases";
import CaseDetail from "./monitoring/case_detail";
import MonitoringRules from "./monitoring/rules";
import MonitoringSettings from "./monitoring/settings";
import MonitoringAudit from "./monitoring/audit";


export default function MainRouter(props) {
  return (
    <Routes>
      <Route index path="/" element={<Dashboard />}></Route>
      <Route path="/products" element={<ProductsHandler />}>
        <Route index path="" element={<Products />} />
        <Route path="category/:id" element={<CategoryProducts />} />
        <Route path="create" element={<CreateProduct />} />
        <Route path=":id" element={<ViewProduct />} />
      </Route>
      <Route path="/customers" element={<CustomersHandler />}>
        <Route index path="" element={<Customers />} />
        <Route path=":id" element={<CustomerDetails />}>
        </Route>
      </Route>
      <Route path="/trades" element={<TradesHandler />}>
        <Route path="" element={<Trades />}>
          <Route path="gift-card" element={<>a</>} />
        </Route>
      </Route>
      <Route path="/withdrawals" element={<Withdrawals />} />
      <Route path="/bvn-watchlist" element={<BvnWatchlist />} />
      <Route path="/monitoring" element={<MonitoringLayout />}>
        <Route index element={<MonitoringOverview />} />
        <Route path="alerts" element={<MonitoringAlerts />} />
        <Route path="alerts/:id" element={<AlertDetail />} />
        <Route path="cases" element={<MonitoringCases />} />
        <Route path="cases/:id" element={<CaseDetail />} />
        <Route path="rules" element={<MonitoringRules />} />
        <Route path="settings" element={<MonitoringSettings />} />
        <Route path="audit" element={<MonitoringAudit />} />
      </Route>
      <Route path="/email-campaigns" element={<Campaigns />} />
      <Route path="/email-campaigns/new" element={<CampaignEditor key="new" />} />
      <Route path="/email-campaigns/:id" element={<CampaignEditor />} />
      <Route path="/orders" element={<OrdersHandler />}>
        <Route index path="" element={<Orders />} />
        <Route path=":id" element={<OrderDetails />} />
      </Route>
      <Route path="/shipping" element={<ShippingHandler />}>
        <Route index path="" element={<Shipping />} />
        <Route path="addresses" element={<ShippingAddress />} />
        <Route path="details/:id" element={<ShippingDetails />} />
        <Route path="drop-off/:id" element={<DropoffDetails />} />
      </Route>
      <Route>
        <Route path="/rates" element={<Rates />}>
          <Route index path="" element={<CryptoRate />} />
          <Route path="sell-crypto" element={<CryptoSellRate />} />
          <Route path="buy-giftcards" element={<Giftcards />} />
          <Route path="sell-giftcards" element={<SellGiftcards />} />
          <Route path="platform-rate" element={<PlatformRate />} />
          <Route index path="shipping" element={<ShippingRate />} />
        </Route>
        <Route path="notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />}>
          <Route index path="" element={<Account />} />
          <Route path="security" element={<Security />} />
          <Route path="banners" element={<Banners />} />
          <Route path="roles" element={<Roles />} />
        </Route>
      </Route>
    </Routes>
  );
}
